import React from 'react';
import { Table } from 'semantic-ui-react';

// Global Components
// @ts-ignore
import TableHeadTableCell from 'components/TableHeadTableCell';

function TimesheetEntriesTableHead(): React.ReactElement {
    return (
        <Table.Header
            // HACK inline styles
            style={{
                fontSize: 14
            }}
        >
            <Table.Row>
                <TableHeadTableCell
                    label="Date"
                    value="date"
                    defaultSort="date_ascending"
                />
                <TableHeadTableCell
                    label="First Name"
                    value="personFirstName"
                    defaultSort="date_ascending"
                />
                <TableHeadTableCell
                    label="Last Name"
                    value="personLastName"
                    defaultSort="date_ascending"
                />
                <TableHeadTableCell
                    label="Task"
                    value="workTypeName"
                    defaultSort="date_ascending"
                />
                <TableHeadTableCell
                    label="Area"
                    value="entityName"
                    defaultSort="date_ascending"
                />
                <TableHeadTableCell
                    label="Start Time"
                    value="startTime"
                    defaultSort="date_ascending"
                />
                <TableHeadTableCell
                    label="End Time"
                    value="endTime"
                    defaultSort="date_ascending"
                />
                <TableHeadTableCell
                    label="Lunch Break"
                    value="unpaidBreakMinutes"
                    defaultSort="date_ascending"
                />
                <TableHeadTableCell
                    label="Paid Break"
                    value="paidBreakMinutes"
                    defaultSort="date_ascending"
                />
                <TableHeadTableCell
                    label="Hours"
                    value="totalPaidMinutes"
                    defaultSort="date_ascending"
                />
                <TableHeadTableCell
                    label="Count"
                    value="units"
                    defaultSort="date_ascending"
                />
                <TableHeadTableCell
                    label="Rate"
                    value="rate"
                    defaultSort="date_ascending"
                />
                <TableHeadTableCell
                    label="Earnings"
                    value="earnings"
                    defaultSort="date_ascending"
                />
                <TableHeadTableCell
                    label="Achieved"
                    value="effectiveRate"
                    defaultSort="date_ascending"
                />
                <TableHeadTableCell
                    label="Paid Break"
                    value="paidBreakDollars"
                    defaultSort="date_ascending"
                />
                <Table.HeaderCell
                    className="events-table-cell-padding"
                    style={{ cursor: 'auto' }}
                />
            </Table.Row>
        </Table.Header>
    );
}

export default TimesheetEntriesTableHead;
